module.exports = __webpack_public_path__ + "assets/mann-ivanov-ferber.ru.ce050f99c343c9758a4ba6afe60328e2240121592dfde66ddb0a173569432549.jpg";